import React from 'react';

const DemoVideo = () => {
  return (
    <section id="demo" className="py-20 px-6 bg-[#050812]">
      <div className="max-w-6xl mx-auto">
        <div className="text-center space-y-6 mb-12 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-bold">
            See SystemCraft in{' '}
            <span className="bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
              Action
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Watch how SystemCraft turns system design into hands-on practice
          </p>
        </div>

        {/* Video container */}
        <div className="relative rounded-2xl overflow-hidden bg-gray-900 border border-gray-800 shadow-2xl">
          <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
            <iframe
              id="js_video_iframe"
              src="https://systemcraft.vnclabs.com/SystemCraft.mp4"
              frameBorder="0"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
              allowFullScreen
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
              title="SystemCraft Demo"
            ></iframe>
          </div>
        </div>

        <p className="text-center text-gray-500 mt-6 text-sm">
          See how engineers design distributed systems with real constraints and trade-offs
        </p>
      </div>
    </section>
  );
};

export default DemoVideo;
